export const provinceCreationPayload = (data) => {
  let objectTemp = {
    name: data.name,
  };

  return objectTemp;
};

export const provinceUpdatePayload = (data) => {
  let objectTemp = {
    name: data.name,
  };

  return objectTemp;
};
